export const EventActions = {
  GENERAL_LOAD: "PAGHomeNav_General_Load",
  IDS_LOAD: "PAGHomeNav_Ids_Load",
  COUNTRY_RECOMMENDER_LOAD: "PAGHomeNav_CountryRecommender_Load",
  COUNTRY_RECOMMENDER_CHANGE: "PAGHomeNav_CountryRecommenderChange_Click",
  COUNTRY_RECOMMENDER_CLOSE: "PAGHomeNav_CountryRecommenderClose_Click",
  CREST_CLICK: "PAGHomeNav_Crest_Click",
  NAVIGATION_LOAD: "PAGHomeNav_Navigation_Load",
  MODEL_OVERLAY_LOAD: "PAGHomeNav_ModelRangeOverlay_Load",
  MENU_BACK_CLICK: "PAGHomeNav_MenuBack_Click",
  MENU_CLOSE_CLICK: "PAGHomeNav_MenuClose_Click",
  META_FUNCTION_CLICK: "PAGHomeNav_MetaFunction_Click",
  MODEL_CLICK: "PAGHomeNav_Model_Click",
  MODEL_META_FUNCTION_CLICK: "PAGHomeNav_ModelMetaFunction_Click",
  MODEL_CTA_CLICK: "PAGHomeNav_ModelCTA_Click",
  MODEL_RANGE_CLICK: "PAGHomeNav_ModelRange_Click",
  MORE_CLICK: "PAGHomeNav_More_Click",
  SHOW_MORE_CLICK: "PAGHomeNav_ShowMore_Click",
  NAVIGATION_CLICK: "PAGHomeNav_Navigation_Click",
  NAVIGATION_LINK_CLICK: "PAGHomeNav_NavigationLink_Click",
  DEALER_SEARCH_SCREEN_LOAD: "PAGHomeNav_FindADealerSearchScreen_Load",
  DEALER_RESULTS_SCREEN_LOAD: "PAGHomeNav_FindADealerResultsScreen_Load",
  DEALER_SEARCH_CLICK: "PAGHomeNav_FindADealerSearch_Click",
  DEALER_DROPDOWN_CLICK: "PAGHomeNav_FindADealerDropdown_Click",
  DEALER_DROPDOWN_SELECT_CLICK: "PAGHomeNav_FindADealerDropdownSelect_Click",
  DEALER_GEOLOCATION_CLICK: "PAGHomeNav_FindADealerLocateMe_Click",
  DEALER_RESULT_CLICK: "PAGHomeNav_FindADealerDealer_Click",
  DEALER_DETAILS_SCREEN_LOAD: "PAGHomeNav_FindADealerDealerScreen_Load",
  DEALER_CONTACT_CLICK: "PAGHomeNav_FindADealerDealerContact_Click",
  DEALER_MAP_CLICK: "PAGHomeNav_FindADealerMap_Click",
  CONTEXTUAL_BUTTON_CLICK: "PAGHomeNav_IconContextLink_Click",
  DRAWER_LOAD: "PAGHomeNav_Drawer_Load",
  PCOM_SEARCH_CLICK: "PAGHomeNav_IconGlobalLink_Click",
  DEALER_LINK_CLICK: "PAGHomeNav_FindADealerDealerLink_Click",
  BUTTON_CLICK: "PAGHomeNav_DSMButton_Click_NAV",
} as const;

export type EventAction = (typeof EventActions)[keyof typeof EventActions];

export const DATA_LAYER_APP_ID = "nav";
export const DATA_LAYER_APPLICATION_NAME = "edgecast_CDN";

export const ElementTypes = {
  closeButton: "close-button",
  backdrop: "backdrop",
  backButton: "back-button",
  showMoreButton: "show-more-button",
  menuItem: "menu-item",
  sideDrawerItem: "side-drawer-item",
  doubleDrawer: "double-drawer",
  singleDrawer: "single-drawer",
  bodyTypeButton: "body-type-button",
  myPorscheDrawer: "my-porsche-drawer",
  dealerSearchForm: "dealer-search-form",
} as const;

export type ElementType = (typeof ElementTypes)[keyof typeof ElementTypes];

export const ClickElementTypes = {
  Link: "link",
  Button: "button",
  Image: "image",
} as const;

export type ClickElementType =
  (typeof ClickElementTypes)[keyof typeof ClickElementTypes];

export const DisplayElementTypes = {
  SingleDrawer: "singleDrawer",
  DoubleDrawer: "doubleDrawer",
} as const;

export type DisplayElementType =
  (typeof DisplayElementTypes)[keyof typeof DisplayElementTypes];

export const DEALER_SEARCH_DISPLAY_ELEMENT_ID =
  "level1-mainmenu_level2-find_a_dealer";
export const DEALER_SEARCH_RESULT_DISPLAY_ELEMENT_ID_DOUBLE_DRAWER =
  "level1-mainmenu_level3-dealer-details";
export const DEALER_SEARCH_TARGET_ELEMENT = "level2_dealer-search-form";
export const DEALER_SEARCH_ELEMENT_TYPE = "level3_dealer-details";
